(() => {
  // app/scripts/catalogues.js
  var componentCopyLink = class extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.btn = this.querySelector("button");
      this.btn.addEventListener("click", (e) => {
        this.copyText = this.querySelector("input");
        this.copyText.select();
        this.copyText.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(this.copyText.value);
      });
    }
  };
  customElements.define("component-copylink", componentCopyLink);
})();
